import { type FC } from 'react';
import FilterOption, {
  SubFilterNodeProps,
} from '../../../components/FilterOption/FilterOption';
import { ICategoryFilterData } from '../../../../../../Interface/ProductsFilterInterface';

type CategoryFilterItemProps = {
  category: ICategoryFilterData;
};

const parentFilterKey = 'category_ids' as const;
const subFilterKey = 'sub_category_ids' as const;

const CategoryFilterItem: FC<CategoryFilterItemProps> = ({ category }) => {
  const subCategory: SubFilterNodeProps[] = [
    ...category.sub_categories
      .filter(
        ({ attributes_count, product_sizes_count }) =>
          (attributes_count ?? product_sizes_count ?? 0) > 0
      )
      .map(({ name, erp_id, attributes_count, product_sizes_count }) => {
        return {
          name: name,
          value: erp_id,
          count: attributes_count ?? product_sizes_count,
          filterKey: subFilterKey,
        };
      }),
  ];

  return (
    <div>
      <FilterOption
        name={category.name}
        value={category.erp_id}
        count={category.product_sizes_count ?? category.attributes_count ?? 0}
        node={subCategory}
        filterKey={parentFilterKey}
      />
    </div>
  );
};

export default CategoryFilterItem;
